import script from "./StatusFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusFunds.vue?vue&type=script&setup=true&lang=js"

import "./StatusFunds.vue?vue&type=style&index=0&id=9ca36ace&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca36ace"]])

export default __exports__